import PaginatedResult from '../dtos/PaginatedResult'
import Audit from '../models/audit'
import { HttpService } from './http'

export type Operation =
  | 'DELETE'
  | 'UPDATE'
  | 'CREATE'
  | 'READ'
  | null
  | undefined

export interface GetAuditInputDto {
  entities: string[]
  recordIds?: string[]
  rootId?: string
  onlyDeleted?: boolean
  startDate?: Date
  endDate?: Date
  userName?: string
  operation?: Operation
  pagination: { page: number; limit: number }
}

const http = new HttpService()

export const getAudits = async (
  params: GetAuditInputDto
): Promise<PaginatedResult<Audit>> => {
  const response = await http.post<GetAuditInputDto, PaginatedResult<Audit>>(
    '/audit',
    params
  )
  return response.data
}

export const downloadAuditReport = async (
  params: GetAuditInputDto
): Promise<void> => {
  try {
    const response = await http.post<GetAuditInputDto, Blob>(
      '/audit/report',
      params,
      {
        responseType: 'blob',
        headers: {
          Accept: 'text/csv',
        },
      }
    )
    let receivedBytes = 0
    const reader = response.data.stream().getReader()
    const chunks = []

    while (true) {
      const { done, value } = await reader.read()
      if (done) break
      chunks.push(value)
      receivedBytes += value.byteLength
      console.log(`Received ${receivedBytes} bytes`)
    }

    const blob = new Blob(chunks, { type: 'text/csv' })
    const url = window.URL.createObjectURL(blob)

    const link = document.createElement('a')
    link.href = url

    const fileName = 'audit-report.csv'
    link.setAttribute('download', fileName)

    // Append to DOM and trigger download
    document.body.appendChild(link)
    link.click()

    // Cleanup
    document.body.removeChild(link)
    window.URL.revokeObjectURL(url)

    return
  } catch (error) {
    console.error(error)
  }
}
